import { formatInputDate } from "./helper";
const now = new Date();
const year = now.getFullYear();

// Get first day of the year
const firstDayOfYear = new Date(year, 0, 1);
export const formattedFirstDayOfYear = formatInputDate(firstDayOfYear);

// Get today's date
const today = new Date();
export const formattedToday = formatInputDate(today);

export let data = {
  title: "Dashboard",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};
export let tabs = [
  { title: "SEMUA", filter: "" },
  { title: "BELUM DIBAYAR", filter: "Belum Dibayar", active: true },
  { title: "BELUM LUNAS", filter: "Belum Lunas" },
  { title: "LUNAS", filter: "Lunas" },
];
export let tabsStatus = [
  { title: "SEMUA", filter: "" },
  { title: "BELUM DIBAYAR", filter: "Belum Dibayar", active: true },
  { title: "BELUM LUNAS", filter: "Belum Lunas" },
  { title: "LUNAS", filter: "Lunas" },
];
export let payments = [
  {
    value: "1",
    label: "Umum",
  },
  {
    value: "2",
    label: "BPJS",
  },
  {
    value: "3",
    label: "Lainnya",
  },
];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru",
  },
  {
    value: "asc",
    label: "Terlama",
  },
];
export let filtersPasien = {
  colnum: "",
  columns: [
    {
      name: "berdasarkan",
      type: "radio",
      colwidth: 3,
      label: "Berdasarkan",
      options: [
        { label: "Pemeriksaan", value: "pemeriksaan" },
        { value: "rekam_medis", label: "Rekam Medis" },
      ],
      value: "pemeriksaan",
    },
    {
      name: "tipe",
      type: "select",
      colwidth: 3,
      label: "Pilih Pasien untuk",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};

export let filtersRujukan = {
  colnum: "",
  columns: [
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};
export let currentYear = new Date().getUTCFullYear();
export let yearOptions = [
  { label: currentYear, value: currentYear },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 },
  { label: currentYear - 3, value: currentYear - 3 },
  { label: currentYear - 4, value: currentYear - 4 },
  { label: currentYear - 5, value: currentYear - 5 },
  { label: currentYear - 6, value: currentYear - 6 },
  { label: currentYear - 7, value: currentYear - 7 },
  { label: currentYear - 8, value: currentYear - 8 - 9 },
  { label: currentYear - 9, value: currentYear - 9 },
  { label: currentYear - 10, value: currentYear - 10 },
  { label: currentYear - 11, value: currentYear - 11 },
  { label: currentYear - 12, value: currentYear - 12 },
  { label: currentYear - 13, value: currentYear - 13 },
  { label: currentYear - 14, value: currentYear - 14 },
  { label: currentYear - 15, value: currentYear - 15 },
  { label: currentYear - 16, value: currentYear - 16 },
  { label: currentYear - 17, value: currentYear - 17 },
  { label: currentYear - 18, value: currentYear - 18 },
  { label: currentYear - 19, value: currentYear - 19 },
  { label: currentYear - 20, value: currentYear - 20 },
];
export let filtersRl3 = {
  colnum: "1",
  columns: [
    {
      label: "",
      type: "select",
      placeholder: "Tahun",
      name: "year",
      value: new Date().getUTCFullYear(),
      mandatory: true,
      options: yearOptions,
    },
  ],
};

export let filtersRl5 = {
  colnum: "",
  columns: [
    {
      label: "",
      type: "date",
      placeholder: "Dari",
      name: "dari",
      value: formattedFirstDayOfYear,
      mandatory: true,
      colwidth: 6,
    },
    {
      label: "",
      type: "date",
      placeholder: "Sampai",
      name: "sampai",
      value: formattedToday,
      mandatory: true,
      colwidth: 6,
    },
  ],
};

export let filtersRl4 = {
  colnum: "",
  columns: [
    {
      label: "",
      type: "date",
      placeholder: "Dari",
      name: "dari",
      value: formattedFirstDayOfYear,
      mandatory: true,
      colwidth: 6,
    },
    {
      label: "",
      type: "date",
      placeholder: "Sampai",
      name: "sampai",
      value: formattedToday,
      mandatory: true,
      colwidth: 6,
    },
  ],
};
export let filtersPenyakit = {
  colnum: "",
  columns: [
    {
      name: "tipe",
      type: "select",
      colwidth: 3,
      label: "Pilih Kasus dari",
      options: [
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "rawat_jalan",
    },
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};
export let singleSelectPenyakit = {
  colnum: "",
  columns: [
    {
      name: "single_select",
      type: "select",
      colwidth: 12,
      label: "Pilih Klasifikasi Penyakit",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
  ],
};
export let filtersObat = {
  colnum: "",
  columns: [
    {
      name: "tipe",
      type: "select",
      colwidth: 3,
      label: "Pilih Kasus dari",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      name: "jenis",
      type: "select",
      colwidth: 3,
      label: "Jenis Obat/Alkes",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};

export let filtersOptik = {
  colnum: "",
  columns: [
    {
      name: "tipe",
      type: "select",
      colwidth: 3,
      label: "Pilih Kasus dari",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      name: "jenis",
      type: "select",
      colwidth: 3,
      label: "Jenis Optik",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};
export let filtersTindakan = {
  colnum: "",
  columns: [
    {
      name: "tipe",
      type: "select",
      colwidth: 3,
      label: "Pilih Kasus dari",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      name: "jenis",
      type: "select",
      colwidth: 3,
      label: "Jenis Tindakan",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};

export let filtersLab = {
  colnum: "",
  columns: [
    {
      name: "tipe",
      type: "select",
      colwidth: 3,
      label: "Pilih Kasus dari",
      options: [
        { value: "all", label: "Semua Pemeriksaan" },
        { value: "rawat_jalan", label: "Rawat Jalan" },
        { value: "rawat_inap", label: "Rawat Inap" },
        { value: "ugd", label: "UGD" },
        { value: "rawat_periksa_lab", label: "Pemeriksaan Lab" },
      ],
      value: "all",
    },
    {
      label: "Dari",
      type: "date",
      placeholder: "Tanggal",
      name: "dari",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
    {
      label: "Sampai",
      type: "date",
      placeholder: "Tanggal",
      name: "sampai",
      value: "",
      mandatory: true,
      colwidth: 3,
    },
  ],
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts,
    },
  ],
};
export let upperTabsPasien = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
    active: true,
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },
  // {
  //   link: "/dashboard/obat",
  //   label: "REKAP OBAT/ALKES"
  // },
  // {
  //   link: "/dashboard/optik",
  //   label: "REKAP OPTIK"
  // },
  // {
  //   link: "/dashboard/tindakan",
  //   label: "TINDAKAN"
  // },
  // {
  //   link: "/dashboard/lab",
  //   label: "LAB"
  // }
];

export let upperTabsPenyakit = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
    active: true,
  },

  // {
  //   link: "/dashboard/obat",
  //   label: "REKAP OBAT/ALKES"
  // },
  // {
  //   link: "/dashboard/optik",
  //   label: "REKAP OPTIK"
  // },
  // {
  //   link: "/dashboard/tindakan",
  //   label: "TINDAKAN"
  // },
  // {
  //   link: "/dashboard/lab",
  //   label: "LAB"
  // }
];

export let upperTabsUgd = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },
  {
    link: "/dashboard/ugd",
    label: "UGD",
    active: true,
  },
  {
    link: "/dashboard/obat",
    label: "REKAP OBAT/ALKES",
  },
  {
    link: "/dashboard/optik",
    label: "REKAP OPTIK",
  },
  {
    link: "/dashboard/tindakan",
    label: "TINDAKAN",
  },
  {
    link: "/dashboard/lab",
    label: "LAB",
  },
];

export let upperTabsObat = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },

  {
    link: "/dashboard/obat",
    label: "REKAP OBAT/ALKES",
    active: true,
  },
  {
    link: "/dashboard/optik",
    label: "REKAP OPTIK",
  },
  {
    link: "/dashboard/tindakan",
    label: "TINDAKAN",
  },
  {
    link: "/dashboard/lab",
    label: "LAB",
  },
];

export let upperTabsOptik = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },

  {
    link: "/dashboard/obat",
    label: "REKAP OBAT/ALKES",
  },
  {
    link: "/dashboard/optik",
    label: "REKAP OPTIK",
    active: true,
  },
  {
    link: "/dashboard/tindakan",
    label: "TINDAKAN",
  },
  {
    link: "/dashboard/lab",
    label: "LAB",
  },
];

export let upperTabsTindakan = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },

  {
    link: "/dashboard/obat",
    label: "REKAP OBAT/ALKES",
  },
  {
    link: "/dashboard/optik",
    label: "REKAP OPTIK",
  },
  {
    link: "/dashboard/tindakan",
    label: "TINDAKAN",
    active: true,
  },
  {
    link: "/dashboard/lab",
    label: "LAB",
  },
];

export let upperTabsLab = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },

  {
    link: "/dashboard/obat",
    label: "REKAP OBAT/ALKES",
  },
  {
    link: "/dashboard/optik",
    label: "REKAP OPTIK",
  },
  {
    link: "/dashboard/tindakan",
    label: "TINDAKAN",
  },
  {
    link: "/dashboard/lab",
    label: "LAB",
    active: true,
  },
];

export let upperTabs = [
  {
    link: "/dashboard/pasien",
    label: "PASIEN",
  },
  {
    link: "/dashboard/penyakit",
    label: "PENYAKIT",
  },
  {
    link: "/dashboard/menular",
    label: "PENYAKIT MENULAR",
  },
  {
    link: "/dashboard/rujukan",
    label: "RUJUKAN",
  },
  {
    link: "/dashboard/bor",
    label: "BED OCCUPANCY RATE",
  },
  {
    link: "/dashboard/alos",
    label: "AVERAGE LENGTH OF STAY",
  },
  {
    link: "/dashboard/bto",
    label: "BED TURNOVER",
  },
  {
    link: "/dashboard/toi",
    label: "TURNOVER INTERVAL",
  },
  {
    link: "/dashboard/ndr",
    label: "NET DEATH RATE",
  },
  {
    link: "/dashboard/gdr",
    label: "GROSS DEATH RATE",
  },
  {
    link: "/dashboard/bj",
    label: "BARBER JOHNSON",
  },
  {
    link: "/dashboard/rl",
    label: "REKAPITULASI LAPORAN",
  },
  {
    link: "/dashboard/ro",
    label: "REKAPITULASI OBAT",
  },
];

export let dataRl = {
  title: "Formulir RL 1",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};

export let dataRl2 = {
  title: "Formulir RL 2 Ketenagaan",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};

export let dataRl3 = {
  title: "Formulir RL 3 Data Kegiatan Pelayanan Rumah Sakit",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};

export let dataRl4 = {
  title: "Formulir RL 4",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};

export let dataRl5 = {
  title: "Formulir RL 5 Data Bulanan",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};
